<i18n>
  {
    "fr": {
      "description": "En relançant la recherche avec ces critères, plus de résultats peuvent être trouvés. Voulez-vous relancer la recherche ?"
    },
    "en": {
      "description": "By repeating the search with these criteria, more results can be found. Would you like to start the search again?"
    }
  }
</i18n>

<template>
  <v-snackbar
    id="refresh-pop-up"
    v-model="isVisible"
    timeout="10000"
  >
    <p
      id="refresh-pop-up-text"
    >
      {{ $t("description") }}
    </p>
    <template #action>
      <v-btn
        color="primaryLight"
        fab
        @click="refreshResearch"
      >
        <v-icon color="black">
          mdi-refresh
        </v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'FlightSearchResultsRefreshPopUp',
  data: () => ({
    isVisible: false
  }),
  computed: {
    ...mapState({
      outwardDepartureDelta: state => state.fb.searchFilters.outwardFlightDepartureDelta,
      returnDepartureDelta: state => state.fb.searchFilters.returnFlightDepartureDelta,
      selectedStopover: state => state.fb.searchFilters.selectedStopover,
      selectedAirlineCompanies: state => state.fb.searchFilters.selectedAirlineCompanies,
      luggageOption: state => state.fb.searchParameters.selectedLuggageOption
    })
  },
  /**
   * Watch all the filter values to display the popup when one of them is changed
   */
  watch: {
    luggageOption () {
      this.isVisible = true
    },
    selectedAirlineCompanies () {
      this.isVisible = true
    },
    selectedStopover () {
      this.isVisible = true
    },
    outwardDepartureDelta () {
      this.isVisible = true
    },
    returnDepartureDelta () {
      this.isVisible = true
    }
  },
  /**
   * Subscribe to the store action and modify isVisible value each time flightSearchAction is fired
   * This allow the popup to be hidden during a research or when a research is relaunched at step 2
   */
  created () {
    this.$store.subscribeAction({
      before: (action) => {
        if (action.type === 'fb/flightSearchAction') {
          this.isVisible = false
        }
      },
      after: (action) => {
        if (action.type === 'fb/flightSearchAction') {
          this.isVisible = false
        }
      }
    })
  },
  methods: {
    /**
     * Call to vueX store research action
     */
    refreshResearch () {
      this.$store.dispatch('fb/flightSearchAction')
    }
  }
}
</script>

<style scoped>
  #refresh-pop-up {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  #refresh-pop-up-text {
    color: white !important;
    padding-left: 12px;
    margin-bottom: 0 !important;
  }
</style>
